// extracted by mini-css-extract-plugin
export default {"card":"_Card_card__P8QOS","noBorder":"_Card_noBorder__sYvvN","disabled":"_Card_disabled__RY364","cardHeader":"_Card_cardHeader__8ai7o"};